import React, { useCallback, useEffect } from 'react'
import {
  $getSelection,
  $isDecoratorNode,
  $isElementNode,
  $isRangeSelection,
  COMMAND_PRIORITY_CRITICAL,
  DELETE_CHARACTER_COMMAND,
  KEY_BACKSPACE_COMMAND,
} from 'lexical'
import { mergeRegister } from '@lexical/utils'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'

export const PreventDecoratorNodeDeletePlugin: React.FC = () => {
  const [editor] = useLexicalComposerContext()

  const onBackspaceCommand = useCallback(() => {
    const selection = $getSelection()
    if ($isRangeSelection(selection) && selection.isCollapsed()) {
      if (selection.anchor.offset === 0) {
        const element = selection.anchor.type === 'element' ? selection.anchor.getNode() : selection.anchor.getNode().getParentOrThrow()

        const prevNode = element.getPreviousSibling()
        if ($isDecoratorNode(prevNode) || ($isElementNode(prevNode) && prevNode.getChildren().some($isDecoratorNode))) {
          return true
        }
      } else {
        const curNode = selection.anchor.getNode()
        if ($isDecoratorNode(curNode) || ($isElementNode(curNode) && curNode.getChildren().some($isDecoratorNode))) {
          return true
        }
      }
    }

    return false
  }, [])

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand(KEY_BACKSPACE_COMMAND, onBackspaceCommand, COMMAND_PRIORITY_CRITICAL),
      editor.registerCommand(DELETE_CHARACTER_COMMAND, onBackspaceCommand, COMMAND_PRIORITY_CRITICAL),
    )
  }, [editor, onBackspaceCommand])

  return null
}
